app.mediator.registerModule(MODULE_NAME__WRAP_MAIN_BTNS, function (app) {

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            this.$rootElem = $('.mod-wrap-main-btns');
            if (!this.$rootElem.length) return;
            this.addMediatorListeners();
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {

            var scope = this;

            app.mediator.addListener(EVENT_NAME__SOCIAL_MEDIA_SHARE_POPUP__CLOSED, function () {
                scope.focusSocialMediaShareButton();
            }, this);
        },
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

        focusSocialMediaShareButton: function () {
            this.$rootElem.find('.social-share-button').focus();
        }

	};
});
